











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.Graph.HistCumulCommand')
    
    export class HistCumulCommand {
        constructor( dateBeginning: Date, dateEnd: Date, binId: number, sensorId: number, minVolume: number, maxVolume: number ) {
            
                this.dateBeginning = dateBeginning;
            
                this.dateEnd = dateEnd;
            
                this.binId = binId;
            
                this.sensorId = sensorId;
            
                this.minVolume = minVolume;
            
                this.maxVolume = maxVolume;
            
        }

        
            public dateBeginning: Date;
        
            public dateEnd: Date;
        
            public binId: number;
        
            public sensorId: number;
        
            public minVolume: number;
        
            public maxVolume: number;
        
    }

    export interface IHistCumulCommand {
        
            dateBeginning: Date;
        
            dateEnd: Date;
        
            binId: number;
        
            sensorId: number;
        
            minVolume: number;
        
            maxVolume: number;
        
    }

    export async function histCumul( command: HistCumulCommand ): Promise<CommandResult<any>>
    export async function histCumul( { dateBeginning, dateEnd, binId, sensorId, minVolume, maxVolume }: IHistCumulCommand ): Promise<CommandResult<any>>
    export async function histCumul( model: any ): Promise<CommandResult<any>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<any>;

        if(model instanceof HistCumulCommand) {
            result = await endpoint.send<CommandResult<any>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<any>>( new HistCumulCommand( model['dateBeginning'], model['dateEnd'], model['binId'], model['sensorId'], model['minVolume'], model['maxVolume'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace HistCumulCommand.ExtraneousTypes {
        

        
    }

